import React from "react";
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import educationList from '../../assets/static/education.json';
import classes from './Education.module.css';

const Education = () => (
	<div>
		<h3>Education</h3>
		<Timeline align="left">
			{educationList.education.map(education => (
				<TimelineItem key={education.id}>
					<TimelineOppositeContent style={{flex: '0 1 0'}}/>
					<TimelineSeparator>
							<TimelineDot variant="outlined" className={classes.TimelineDot}/>
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent>
						<Typography className={classes.Title}>{education.title}</Typography>
						<Typography className={classes.Year}>{education.year}</Typography>
						<Typography className={classes.University}>{education.university}</Typography>
					</TimelineContent>
				</TimelineItem>
			))}
		</Timeline>
	</div>
);

export default Education;
